import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
} from '@mui/material';

import { ToastContainer } from "react-toastify";

const AddCertificateDialog = ({ open, onClose, onSave }) => {
    const [certificate, setCertificate] = useState({
        name: '',
        issuingOrganization: '',
        issueDate: '',
        skills: '',
        links: ''
    });

    const handleCertificateChange = (e) => {
        const { name, value } = e.target;
        setCertificate((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        const formattedCertificate = {
            ...certificate,
            skills: certificate.skills ? certificate.skills.split(',').map(skill => skill.trim()).filter(skill => skill) : [],
            links: certificate.links ? certificate.links.split(',').map(link => link.trim()).filter(link => link) : []
        };

        onSave(formattedCertificate);

        // Reset form
        setCertificate({
            name: '',
            issuingOrganization: '',
            issueDate: '',
            skills: '',
            links: ''
        });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Add Certificate</DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    label="Certificate Name"
                    name="name"
                    value={certificate.name}
                    onChange={handleCertificateChange}
                    margin="normal"
                    required
                />
                <TextField
                    fullWidth
                    label="Issuing Organization"
                    name="issuingOrganization"
                    value={certificate.issuingOrganization}
                    onChange={handleCertificateChange}
                    margin="normal"
                />
                <TextField
                    fullWidth
                    label="Issue Date"
                    name="issueDate"
                    type="date"
                    value={certificate.issueDate}
                    onChange={handleCertificateChange}
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                />
                <TextField
                    fullWidth
                    label="Skills"
                    name="skills"
                    value={certificate.skills}
                    onChange={handleCertificateChange}
                    margin="normal"
                    placeholder="Add skills separated by commas"
                />
                <TextField
                    fullWidth
                    label="Links"
                    name="links"
                    value={certificate.links}
                    onChange={handleCertificateChange}
                    margin="normal"
                    placeholder="Add certificate links separated by commas"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary" variant="contained">
                    Add Certificate
                </Button>
            </DialogActions>
            <ToastContainer
                position='bottom-center'
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </Dialog>
    );
};

export default AddCertificateDialog;